// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/dimensions/archive',
        component: () =>
            import('@/pages/[organisation]/accounting/dimensions/archive.vue'),
        name: 'accounting.dimensions.archived-dimensions',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.dimensions.view-dimensions',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/dimensions/archive/[id].vue'),
                name: 'accounting.dimensions.view-archived-dimension',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.dimensions.view-dimensions',
                },
            },
        ],
    },

    {
        path: '/:organisation/accounting/dimensions',
        component: () =>
            import('@/pages/[organisation]/accounting/dimensions.vue'),
        name: 'accounting.dimensions.search-dimensions',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.dimensions.view-dimensions',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/accounting/dimensions/new.vue'),
                name: 'accounting.dimensions.create-dimension',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.dimensions.create-dimension',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/dimensions/[id].vue'),
                name: 'accounting.dimensions.view-dimension',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.dimensions.view-dimensions',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/accounting/dimensions/[id]/edit.vue'),
                name: 'accounting.dimensions.update-dimension',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.dimensions.update-dimension',
                },
            },
        ],
    },
];
